import { combineReducers } from 'redux';
import settings from './settings/reducer';
import menu from './menu/reducer';
import authUser from './auth/reducer';
import external_review from './external_review/reducer';
import upload from './upload/reducer';
import dashboard from './dashboard/reducer';
import catalogList from './catalogList/reducer';
import orp from './orp/reducer';
import orpcompras from './orpcompras/reducer';
import validateEmailUser from './validate_email/reducer';
import basket from './basket_medicine/reducer';
import menuRole from './menuRole/reducer';
import articleCard from './article_card/reducer';

const reducers = combineReducers({
    menu,
    settings,
    external_review,
    upload, 
    dashboard,
    catalogList,
    authUser,
    orp,
    orpcompras,
    validateEmailUser,
    basket,
    menuRole,
    articleCard
});

export default reducers;
